import type { NextPage } from 'next'
import styles from '../../styles/ButtonText.module.scss'
import { joinClassnames } from 'helpers/classNames'
import { Size } from 'types/size'
import { Type } from 'types/type'

interface Props {
  text: string
  type?: Type
  size?: Size
  onClick: any
}
const ButtonText: NextPage<Props> = (props: Props) => {
  const type = props.type
  const size = props.size
  const text = props.text
  const onClick = props.onClick
  
  const classNames = joinClassnames([
    styles.bg_white, 
    size === Size.small && styles.small,
    size === Size.medium && styles.medium,
    size === Size.large && styles.large,
    size === Size.xLarge && styles.xLarge,
    size === Size.xxLarge && styles.xxLarge,
    type === Type.dark && styles.dark,
    type === Type.light && styles.light,
    type === Type.t1 && styles.t1,
    type === Type.t2 && styles.t2,
    type === Type.t3 && styles.t3,
    type === Type.t4 && styles.t4,
    type === Type.t5 && styles.t5,
    type === Type.t6 && styles.t6,
    type === Type.t7 && styles.t7,
    type === Type.primary && styles.primary,
  ])
  return (
    <div className={classNames} onClick={onClick}>
      <div className={styles.text}>{text}</div>
    </div>
  )
}

export default ButtonText
